/** Browser notifications when a joined ride starts. */
export class RideNotificationService {
  async notifyRideStarted(rideId: string, rideTitle: string, startedByName: string): Promise<void> {
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;
    if (document.visibilityState === 'visible') return;

    const notification = new Notification('Ride Started', {
      body: `🏍 ${rideTitle} has started.\nStarted by ${startedByName}`,
      tag: `ridemaadi-ride-started-${rideId}`,
      data: { rideId },
    });

    notification.onclick = () => {
      window.focus();
      window.location.assign(`/rides/${rideId}`);
      notification.close();
    };
  }

  async ensurePermission(): Promise<NotificationPermission> {
    if (!('Notification' in window)) return 'denied';
    if (Notification.permission === 'granted') return 'granted';
    if (Notification.permission === 'denied') return 'denied';
    return Notification.requestPermission();
  }
}

export const rideNotificationService = new RideNotificationService();
